import { render } from "./VideoBox.vue?vue&type=template&id=4d971eea"
import script from "./VideoBox.vue?vue&type=script&lang=js"
export * from "./VideoBox.vue?vue&type=script&lang=js"

import "./VideoBox.vue?vue&type=style&index=0&id=4d971eea&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__